var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 232,
    viewBox: "0 0 320 232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "default",
    transform: "translate(-227 -418)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9610",
    "data-name": "Rectangle 9610",
    width: 320,
    height: 232,
    rx: 13,
    transform: "translate(227 418)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "car-svgrepo-com",
    transform: "translate(347.787 477.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3997",
    "data-name": "Group 3997",
    transform: "translate(0 20.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3996",
    "data-name": "Group 3996",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5275",
    "data-name": "Path 5275",
    d: "M70.459,259.972a6.258,6.258,0,1,0,6.258,6.258A6.265,6.265,0,0,0,70.459,259.972Zm0,9.392a3.134,3.134,0,1,1,3.134-3.134A3.137,3.137,0,0,1,70.459,269.364Z",
    transform: "translate(-54.171 -222.566)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5276",
    "data-name": "Path 5276",
    d: "M364.2,259.972a6.258,6.258,0,1,0,6.258,6.258A6.265,6.265,0,0,0,364.2,259.972Zm0,9.392a3.134,3.134,0,1,1,3.134-3.134A3.137,3.137,0,0,1,364.2,269.364Z",
    transform: "translate(-302.02 -222.566)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5277",
    "data-name": "Path 5277",
    d: "M120.675,57.01a1.562,1.562,0,0,0-1.562-1.562H95.539a1.562,1.562,0,1,0,0,3.124h23.573A1.562,1.562,0,0,0,120.675,57.01Z",
    transform: "translate(-79.296 -49.993)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5278",
    "data-name": "Path 5278",
    d: "M279.44,58.572h2.392a1.562,1.562,0,0,0,0-3.124H279.44a1.562,1.562,0,0,0,0,3.124Z",
    transform: "translate(-234.467 -49.993)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5279",
    "data-name": "Path 5279",
    d: "M207.013,334.742H190.859a1.562,1.562,0,1,0,0,3.124h16.154a1.562,1.562,0,1,0,0-3.124Z",
    transform: "translate(-159.725 -285.655)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5280",
    "data-name": "Path 5280",
    d: "M76.861,39.244H70.05V28.41a7.891,7.891,0,0,0-7.882-7.882H16.255A7.891,7.891,0,0,0,8.373,28.41V39.244H1.562A1.562,1.562,0,0,0,0,40.806V46.87a1.562,1.562,0,0,0,1.562,1.562h1.8a8.764,8.764,0,0,0-2.1,5.693V77.293a1.562,1.562,0,0,0,1.562,1.562h2.2V85.89a6.655,6.655,0,0,0,6.647,6.647h1.3a6.655,6.655,0,0,0,6.647-6.647V78.855H58.145V85.89a6.655,6.655,0,0,0,6.647,6.647h1.3a6.655,6.655,0,0,0,6.647-6.647V78.855H75.6a1.562,1.562,0,0,0,1.562-1.562V54.125a8.765,8.765,0,0,0-2.1-5.693h1.8a1.562,1.562,0,0,0,1.562-1.562V40.806A1.562,1.562,0,0,0,76.861,39.244ZM11.5,28.41a4.763,4.763,0,0,1,4.758-4.758H62.168a4.763,4.763,0,0,1,4.758,4.758v16.91H53.2l7.558-2.132a1.562,1.562,0,0,0-.9-2.993L42.775,45.321H28.131l7.615-2.161a1.562,1.562,0,0,0-.9-2.993L17.67,45.321H11.5V28.41Zm-8.373,16.9v-2.94H8.36v2.94H3.124Zm9.854,44.1h-1.3A3.527,3.527,0,0,1,8.152,85.89v-7H16.5v7h0A3.527,3.527,0,0,1,12.979,89.413Zm53.117,0h-1.3a3.527,3.527,0,0,1-3.523-3.523v-7h8.349v7h0A3.527,3.527,0,0,1,66.1,89.413ZM74.034,75.73H4.389v-21.6a5.687,5.687,0,0,1,5.681-5.681H68.354a5.687,5.687,0,0,1,5.681,5.681ZM75.3,45.308H70.063v-2.94H75.3Z",
    transform: "translate(0 -20.528)",
    fill: "#b7b7b7"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCar);
export default __webpack_public_path__ + "static/media/default_car.61194c04675de71f11fab49ecfd4654b.svg";
export { ForwardRef as ReactComponent };